import React, {useEffect, useState} from 'react';
import {Pie} from "@ant-design/plots";
import {DatePicker, Select} from "antd";
import dayjs from "dayjs";
import moment from "moment/moment";
import {API_PATH} from "../../components/const";
import axios from "axios";
import {toast} from "react-toastify";

const dateFormat = 'YYYY-MM-DD';


const {RangePicker} = DatePicker;


const Pie2 = () => {
    const [time, setTime] = useState(new Date());
    const [data, setData] = useState([])
    const [dataTotal, setDataTotal] = useState(0)
    const [offices, setOffices] = useState([])
    const [selectOffices, setSelectOffices] = useState(null)
    const [firstDay, setFirst] = useState("")
    const [lastDay, setLast] = useState("")



    const config = {
        appendPadding: 10,
        data,
        angleField: 'total_time',
        colorField: 'service_title',
        radius: 0.9,
        color:['#FC53F5', '#5664D2', '#00E480', '#FF3542', '#0090EB', '#FFB100', '#4D4F6C'],
        label: {
            type: 'inner',
            offset: '-30%',
            content: ({percent}) => `${(percent * 100).toFixed(0)}%`,
            style: {
                fontSize: 14,
                textAlign: 'center',
            },
        },
        interactions: [
            {
                type: 'element-active',
            },
        ],
    };
    const getBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') +  "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res?.data)
                setSelectOffices(res?.data[0]?.id)

                if (res?.data?.items?.length > 0 ){
                    axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/roi/services/times/by/period?building_id="+ res?.data?.items[0]?.id +"&start_date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + 1 + "&end_date_str=" + moment().endOf('month').format('YYYY-MM-DD') , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                        .then(res => {
                            setData(res?.data)
                        })
                }
                axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/roi/total/service/time/by/period?building_id="+ res?.data?.items[0]?.id +"&start_date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + 1 + "&end_date_str=" + moment().endOf('month').format('YYYY-MM-DD') , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                    .then(res => {
                        setDataTotal(res?.data)
                    })
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }

    function onChange(date, dateString) {
        //
        // console.log(dateString[0])
        if (dateString[0] !== "" && dateString[1] !== ""){
            axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/roi/services/times/by/period?building_id="+ selectOffices +"&start_date_str=" +   dateString[0]  + "&end_date_str=" +  dateString[1] , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setData(res?.data)
                    setFirst(dateString[0])
                    setLast(dateString[1])
                })

        } else (
            axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/roi/services/times/by/period?building_id="+ selectOffices +"&start_date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + 1 + "&end_date_str=" + moment().endOf('month').format('YYYY-MM-DD') , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setData(res?.data)
                    setFirst( time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + 1 )
                    setLast( moment().endOf('month').format('YYYY-MM-DD') )
                })
        )
    }

    const onChangeBuild = (e) => {
        setSelectOffices(e)
        if (lastDay !== "" && firstDay !== ""){
            axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/roi/services/times/by/period?building_id="+ e +"&start_date_str="+ firstDay + "&end_date_str=" + lastDay, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setData(res?.data)
                })
        } else (
            axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/roi/services/times/by/period?building_id="+ e +"&start_date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + 1 + "&end_date_str=" + moment().endOf('month').format('YYYY-MM-DD') , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setData(res?.data)
                })
        )

    }
    useEffect(() => {
        // getData()
        getBuilding()
        // setFirst(time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + 1 )
        // setLast( moment().endOf('month').format('YYYY-MM-DD') )
    }, []);

    return (
        <div>
            <div className="chart-box mt-3">

                <div className="visitor-title">
                    <h1><span>
                  Service portion <br/> by service time
                </span>
                        <div>
                            <Select
                                showSearch
                                placeholder="Выберите филиал"
                                optionFilterProp="children"
                                className="mr-16"
                                onSearch={getBuilding}
                                value={selectOffices}
                                style={{width: "200px"}}
                                onChange={(e) => {
                                    onChangeBuild(e)
                                }}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={offices?.map((item) => {
                                    return {
                                        value: item.building_id,
                                        label:
                                        item?.branch_title
                                    };
                                })}
                            />
                           <RangePicker
                                placeholder={["Дата начала", "Дата окончания"]}
                                defaultValue={[dayjs(moment().startOf('month').format('YYYY-MM-DD'), dateFormat), dayjs(moment().endOf('month').format('YYYY-MM-DD'), dateFormat)]}
                                style={{width: "260px"}}

                                format={dateFormat}
                                onChange={onChange}
                            />
                        </div>
                    </h1>
                </div>
                <div className="d-flex justify-content-end">
                    <h4 className="pie-title">{dataTotal + " "} h</h4>
                </div>
                <Pie {...config} />
            </div>
        </div>
    );
};

export default Pie2;